import { render, staticRenderFns } from "./Projeto.vue?vue&type=template&id=ce109bd0&scoped=true"
import script from "./Projeto.vue?vue&type=script&lang=js"
export * from "./Projeto.vue?vue&type=script&lang=js"
import style0 from "./Projeto.vue?vue&type=style&index=0&id=ce109bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce109bd0",
  null
  
)

export default component.exports